import type { StandardPageInput } from 'types/graphql';

const FindLayout = gql`
  query FindTagLayoutQuery($name: String!) {
    tagLayout(name: $name) {
      id
      name
      schema
      templateState
      schemaVersion
      tagType
    }
  }
`;

/**
 * The load modal's read (P7-R35): one `tagLayoutPage` of v2 layouts (the modal only opens v2 layouts, so the server
 * filters them), oldest first, with an optional name search and `after` for "Show more".
 */
const FindLayouts = gql`
  query FindTagLayoutsQuery($input: StandardPageInput!) {
    tagLayoutPage(input: $input) {
      edges {
        node {
          id
          name
          schema
          templateState
          schemaVersion
          tagType
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const LOAD_MODAL_PAGE_SIZE = 50;

/** The load modal's page input; every request carries the v2 filter. */
export const loadModalPageInput = (searchText = '', after?: string): StandardPageInput => ({
  first: LOAD_MODAL_PAGE_SIZE,
  gridFilters: [{ field: 'schemaVersion', where: [{ equals: 2 }] }],
  sortItems: [{ field: 'id', sort: 'asc' }],
  ...(searchText ? { searchText } : {}),
  ...(after ? { after } : {}),
});

export default { FindLayout, FindLayouts };
